import { gql, useMutation } from "@origin-digital/kraxi";
import { lpgClient } from "./queries";
import {
  UpdateAccountContactDob,
  UpdateAccountContactDobVariables,
} from "./graphql-types/UpdateAccountContactDob";
import {
  UpdateAccountContactEmail,
  UpdateAccountContactEmailVariables,
} from "./graphql-types/UpdateAccountContactEmail";
import {
  UpdateAccountContactMobile,
  UpdateAccountContactMobileVariables,
} from "./graphql-types/UpdateAccountContactMobile";
import {
  UpdateAccountContactPostalAddress,
  UpdateAccountContactPostalAddressVariables,
} from "./graphql-types/UpdateAccountContactPostalAddress";
import {
  UpdateAccountContactHomePhone,
  UpdateAccountContactHomePhoneVariables,
} from "./graphql-types/UpdateAccountContactHomePhone";
import {
  UpdateLpgAccountProfileContactPreference,
  UpdateLpgAccountProfileContactPreferenceVariables,
} from "./graphql-types/UpdateLpgAccountProfileContactPreference";

export const useUpdateDob = () =>
  useMutation<UpdateAccountContactDob, UpdateAccountContactDobVariables>(
    gql`
      mutation UpdateAccountContactDob(
        $accountNumber: String!
        $dateOfBirth: Date!
      ) {
        updateAccount(
          updateAccountDetails: {
            accountNumber: $accountNumber
            contact: { dateOfBirth: $dateOfBirth }
          }
        ) {
          contact {
            dateOfBirth
          }
        }
      }
    `,
    {
      client: lpgClient,
    }
  );

export const useUpdateEmail = () =>
  useMutation<UpdateAccountContactEmail, UpdateAccountContactEmailVariables>(
    gql`
      mutation UpdateAccountContactEmail(
        $accountNumber: String!
        $email: String!
      ) {
        updateAccount(
          updateAccountDetails: {
            accountNumber: $accountNumber
            billing: { email: $email }
          }
        ) {
          billing {
            email
          }
        }
      }
    `,
    {
      client: lpgClient,
    }
  );

export const useUpdateMobile = () =>
  useMutation<UpdateAccountContactMobile, UpdateAccountContactMobileVariables>(
    gql`
      mutation UpdateAccountContactMobile(
        $accountNumber: String!
        $mobile: String!
      ) {
        updateAccount(
          updateAccountDetails: {
            accountNumber: $accountNumber
            contact: { mobile: $mobile }
          }
        ) {
          contact {
            mobile
          }
        }
      }
    `,
    {
      client: lpgClient,
    }
  );

export const useUpdateHomePhone = () =>
  useMutation<
    UpdateAccountContactHomePhone,
    UpdateAccountContactHomePhoneVariables
  >(
    gql`
      mutation UpdateAccountContactHomePhone(
        $accountNumber: String!
        $homephone: String!
      ) {
        updateAccount(
          updateAccountDetails: {
            accountNumber: $accountNumber
            contact: { landline: $homephone }
          }
        ) {
          contact {
            landline
          }
        }
      }
    `,
    {
      client: lpgClient,
    }
  );

export const useUpdatePostalAddress = () =>
  useMutation<
    UpdateAccountContactPostalAddress,
    UpdateAccountContactPostalAddressVariables
  >(
    gql`
      mutation UpdateAccountContactPostalAddress(
        $accountNumber: String!
        $postalAddress: AustralianAddressInput!
      ) {
        updateAccount(
          updateAccountDetails: {
            accountNumber: $accountNumber
            billing: { postalAddress: $postalAddress }
          }
        ) {
          billing {
            postalAddress
          }
        }
      }
    `,
    {
      client: lpgClient,
    }
  );

export const useUpdateLpgAccountProfileContactPreference = () => {
  return useMutation<
    UpdateLpgAccountProfileContactPreference,
    UpdateLpgAccountProfileContactPreferenceVariables
  >(
    gql`
      mutation UpdateLpgAccountProfileContactPreference(
        $accountNumber: String!
        $preference: DeliveryType!
      ) {
        updateAccount(
          updateAccountDetails: {
            accountNumber: $accountNumber
            billing: { type: $preference }
          }
        ) {
          billing {
            type
            postalAddress
            email
          }
        }
      }
    `,
    {
      client: lpgClient,
    }
  );
};
